// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3Nwik","title":"ClientCherryInfo_title__Eu5I2","itemText":"ClientCherryInfo_itemText__2D7IL"};